export default __webpack_public_path__ + "static/media/icn_copy.e9c85412.svg";